module.exports = __webpack_public_path__ + "img/law2-m@2.1cefa8b1.jpg";